import React, { useState, useEffect } from 'react';
import './NewMinority.css'
import loadingimg from "../../assets/images/loading.jpg.gif"

const Minority = () => {
  const [selectedGender, setSelectedGender] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedDiv, setSelectedDiv] = useState('');
  const [selectedCaste, setSelectedCaste] = useState('');
  const [selectedMinority, setSelectedMinority] = useState('');
  const [selectedRegister, setSelectedRegister] = useState('');
  const [students, setStudents] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);

  const [loading, setLoading] = useState(true); 
  const [logoURL, setLogoURL] = useState(null);
  const [schoolData, setSchoolData] = useState(null);
  const udiseNumber = localStorage.getItem("udiseNumber");

  const romanToInt = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
  };
  
  const marathiToInt = {
    'पहिली': 1,
    'दुसरी': 2,
    'तिसरी': 3,
    'चौथी': 4,
    'पाचवी': 5,
    'सहावी': 6,
    'सातवी': 7,
    'आठवी': 8,
    'नववी': 9,
    'दहावी': 10,
    'अकरावी':11,
    'बारावी': 12
  };

  const language = localStorage.getItem('language') || 'English';
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version
  
      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };
  
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
  
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };


   const [classes, setClasses] = useState([]); // To hold class names
    const [divisions, setDivisions] = useState({}); // To hold divisions for each class
  
    const fetchClassDivData = async () => {
      try {
        const storedDivClasses = localStorage.getItem("classDiv");
        if (storedDivClasses) {
          const data = JSON.parse(storedDivClasses);
          
          const classList = [];
          const divisionList = {};
    
          for (const [className, value] of Object.entries(data)) {
            if (value === true) {
              // Class without divisions
              classList.push(className);
              divisionList[className] = []; // Initialize with an empty array
            } else if (typeof value === 'object') {
              // Class with divisions
              classList.push(className);
              divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
            }
          }
    
          setClasses(classList);
          setDivisions(divisionList); // Set the divisionList as the state
        }
      } catch (error) {
        console.error("Error fetching classDiv data: ", error);
      }
    };
    // const allDivisions = Object.values(divisions).flat();
  
    useEffect(() => {
      fetchClassDivData();
    }, [udiseNumber]);

    const fetchDataByFilters = async () => {
      try {
        setLoading(true);
        const db = await openIndexedDB();
        const transaction = db.transaction(['studentData'], 'readonly');
        const objectStore = transaction.objectStore('studentData');
        const allRecords = objectStore.getAll();
  
        allRecords.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            let filteredData = data.filter(student => student && student.isMinority === true);
  
            filteredData = filteredData.filter(student => student.isActive !== false); // Only include active students

            // Apply additional filters if needed
            if (selectedGender) {
              filteredData = filteredData.filter(student => student.gender === selectedGender);
            }
            if (selectedCaste) {
              filteredData = filteredData.filter(student => student.caste === selectedCaste);
            }
            if (selectedClass) {
              filteredData = filteredData.filter(student => student.currentClass && student.currentClass.trim() === selectedClass.trim());
            }
            if (selectedDiv) {
              filteredData = filteredData.filter(student => student.division === selectedDiv);
            }
            if (selectedRegister) {
              filteredData = filteredData.filter(student => student.registerNo === selectedRegister);
            }
  
            setStudents(filteredData);
          }
        };
  
        allRecords.onerror = (event) => {
          console.error('Error fetching student data from IndexedDB:', event.target.error);
        };
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // End loading
      }
    };
  
  

  useEffect(() => {
    fetchDataByFilters();
  }, [selectedGender, selectedCaste, selectedClass, selectedRegister, udiseNumber, selectedDiv,selectedMinority]);


  const handleGenderChange = (event) => {
    setSelectedGender(event.target.value);
  };

   const handleClassChange = (e) => {
    const selectedClass = e.target.value;
    setSelectedClass(selectedClass);

    // Update divisions based on selected class
    if (selectedClass && divisions[selectedClass]) {
      const filteredDivisions = divisions[selectedClass].filter(div => div);
      setDivisionOptions(filteredDivisions);
    } else {
      setDivisionOptions([]);
    }
  };

  const handleDivisionChange = (e) => {
    setSelectedDiv(e.target.value);
  };

  const handleClearData = () => {
    window.location.reload();
    setSelectedGender('');
    setSelectedMinority('');
    setSelectedClass('');
    setSelectedDiv('');
    setSelectedCaste('');
    setSelectedRegister('');
    setStudents([]);
  };
  



const handlePrint = () => {
  const printContent = document.querySelector('.table-responsive'); // Adjust selector to match your layout

  if (printContent) {
    const cloneContent = printContent.cloneNode(true); // Clone the main content

    // Open a new window for printing
    const printWindow = window.open('', '', 'height=800,width=1000');
    printWindow.document.write(`
      <html>
        <head>
          <style>
            @page {
              size: A4 landscape;
              margin: 3mm;
              padding: 15px;
              border: 1px solid black;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
            }
            table {
              border-collapse: collapse;
              width: 100%;
              font-size: 16px;
            }
            th, td {
              border: 1px solid black;
              text-align: center;
              padding: 5px;
            }
            td {
              font-size: 16px;
            }
            th {
              background-color: #82CAFA;
            }
            .print-button {
              display: none;
            }
            .school-header-container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            .school-header2 {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex: 0 0 auto; /* Prevent this section from growing */
              margin-right: 10px;
            }
            .school-header2 img {
              max-height: 70px;
            }
            .school-header {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center; margin-left:-70px;
              flex: 1 1 auto; /* This makes the school header take available space */
            }
            .school-header h1 {
              font-size: 28px;
              margin: 5px 0;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .school-header .report-title {
              font-size: 20px;
              margin: 5px auto;
              font-weight: bold;
              border: 1px solid black;
              width: 200px;
              padding: 5px;
              text-align: center;
              border-radius: 10px;
              background-color: black;
              color: white;
            }
            .school-header .report-tit {
              font-size: 16px;
              margin: 5px auto;
              font-weight: bold;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="school-header-container">
              <div class="school-header2">
                ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
              </div>
              <div class="school-header">
                <div style="margin-left: 15px;">
                  <h1>${schoolData ? schoolData.schoolName : " "}</h1>
                  <div class="report-tit">
                    ${language === 'English' ? 'Taluka' : 'तालुका'} ${schoolData ? schoolData.taluka : " "} , ${language === 'English' ? 'District' : 'जिल्हा'} : ${schoolData ? schoolData.jilha : " "}
                  </div>
                  <div class="report-title">
                      ${language === "English" ? "Minority Report" : "अल्पसंख्यांक अहवाल"}
                  </div>
                </div>
              </div>
            </div>
          <style>
            .styled-table {
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            }
          </style>
          ${cloneContent.outerHTML}
        </body>
      </html>
`);
    printWindow.document.close();

    // Focus and print the window after the image is loaded
    if (logoURL) {
      const img = printWindow.document.querySelector('.school-header2 img');
      img.onload = () => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
    } else {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }
  } else {
    console.error('Content to print not found');
  }
};


  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo); // Set the logo URL
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
    fetchSchoolData ();
}, [udiseNumber]);



  return (
    <div >
      {/* <Sidebar /> */}
      <div className='main-content-of-page'>
      <style>
          {`
            @media print {
              .table th,
              .table td {
                background-color: transparent !important;
                -webkit-print-color-adjust: exact;
              }
              .bg-secondary {
                background-color: transparent !important;
              }
              .print-button {
                display: none;
              }
              .custom-heading-text{
                margin: -5px auto;
              }
            
            }
          `}
        </style>
        
        <center style={{borderBottom : '0.5px solid gray', padding:'-10px', marginBottom:'20px' }}>
          <div id="print-title" className="text-center" style={{ marginTop: '10px', fontWeight: 'bold' }}></div>
          <div className="custom-heading"  style={{paddingBottom:'-20px', marginTop:'-10px'}}>
            <h3  className='text-center mb-2' style={{ color:'#1B4332', fontWeight:'600'}}>{language === "English" ? "Minority Report" : "अल्पसंख्यांक अहवाल"}</h3>
            
          </div>
        </center>
        <div>
          <center>
            <label className='genderOption' htmlFor="gender" style={{ fontWeight: 'bold', fontFamily: 'Times New Roman', fontSize: '15px', marginRight: '10px' }}>{language === "English" ? "Select Gender" : "लिंग निवडा"}</label>
            <select id="gender" value={selectedGender} onChange={handleGenderChange} className="brown-dropdown dropdown" style={{ marginRight: '10px', width:'90px' }}>
              <option value="">{language === "English" ? "Select" : "निवडा"}</option>
              <option value="male">{language === "English" ? "Male" : "मुलगा"}</option>
              <option value="female">{language === "English" ? "Female" : "मुलगी"}</option>
            </select>

            <label htmlFor="classDropdown" className="dropdown-label" style={{ fontWeight: 'bold', fontFamily: 'Times New Roman', fontSize: '15px', marginLeft:'20px' }}>{language === "English" ? "Select Class" : "वर्ग निवडा"}</label>
            <select id="classDropdown" value={selectedClass} onChange={handleClassChange} className="brown-dropdown dropdown" style={{ width:'90px' }}>
              <option value="">{language === "English" ? "Select" : "निवडा"}</option>
              
              {classes
  .filter(cls => cls !== null && cls !== undefined && cls !== '') // Filter out null and undefined classes
  .sort((a, b) => {
    const classA = a.split(' ')[1];
    const classB = b.split(' ')[1];
    let numA, numB;

    if (language === "English") {
      numA = romanToInt[classA] !== undefined ? romanToInt[classA] : 0; // Default to 0 if not found
      numB = romanToInt[classB] !== undefined ? romanToInt[classB] : 0; // Default to 0 if not found
    } else {
      numA = marathiToInt[classA] !== undefined ? marathiToInt[classA] : 0; // Default to 0 if not found
      numB = marathiToInt[classB] !== undefined ? marathiToInt[classB] : 0; // Default to 0 if not found
    }

    return numA - numB; 
  })
  .map((cls, index) => (
    <option key={index} value={cls}>
      {cls}
    </option>
  ))}
            </select>

            <label htmlFor="DivDropdown" className="dropdown-label" style={{ fontWeight: 'bold', fontFamily: 'Times New Roman', fontSize: '15px',marginLeft:'25px' }}>{language === "English" ? "Select Division" : "तुकडी निवडा"}</label>
            <select id="DivDropdown" value={selectedDiv} onChange={handleDivisionChange} className="brown-dropdown dropdown" style={{ width:'90px',marginLeft:'5px' }}>
            <option value="">{language === "English" ? "Select" : "निवडा"}</option>
                      {divisionOptions.map((div, index) => (
                        <option key={index} value={div}>
                          {div}
                        </option>
                      ))}
                    </select>

          </center>
          <div>
            <button className='btn btn-primary' onClick={handleClearData} style={{ marginLeft: '10px' }}>Clear</button>
            <button onClick={handlePrint} className="btn btn-primary float-end">Print</button>
          </div>
        </div>

        <br />
        <hr/>
        <div className='table-responsive mb-5'>
        {loading ? (
                  <div className='loading-overlay'>
                    <div  className="text-center">
                      <img src={loadingimg} style={{width:'100px'}} alt="Loading..." /> 
                    </div>
                  </div>
               
              ):(
  Object.entries(
    students.reduce((acc, student) => {
      const className = student.currentClass ? student.currentClass.trim() : 'Unknown Class'; // Trim here
      if (!acc[className]) {
        acc[className] = [];
      }
      acc[className].push(student);
      return acc;
    }, {})
  ).map(([className, classStudents]) => (
    <div key={className}>
      <h5><u>{className}</u></h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>{language === "English" ? "Sr. No" : "अनु क्रमांक "}</th>
            <th>{language === "English" ? "Student ID" : "विद्यार्थी क्रमांक"}</th>
            <th>{language === "English" ? "Name" : "नाव"}</th>
            <th>{language === "English" ? "Division" : "तुकडी"}</th>
            <th>{language === "English" ? "Adhar No" : "आधार क्रमांक"}</th>
            <th>{language === "English" ? "Gender" : "लिंग"}</th>
            <th>{language === "English" ? "Caste" : "जात"}</th>
            <th>{language === "English" ? "District" : "जिल्हा"}</th>
          </tr>
        </thead>
        <tbody>
          {classStudents.map((student, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{student.studentId}</td>
              <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
              <td>{student.division}</td>
              <td>{student.stdAdharNo}</td>
              <td>
                {language === 'English'
                  ? student.gender
                  : student.gender === 'female'
                    ? 'मुलगी'
                    : student.gender === 'male'
                      ? 'मुलगा'
                      : student.gender}
              </td>
              <td>{student.caste}</td>
              <td>{student.district}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ))
       ) }
</div>
      </div>





            <style jsx>
                  {`
                    .loading-overlay {
                      position: fixed;
                      top: 0;
                      right: 0;
                      width: 88.5%;
                      height: 100%;
                      background: rgba(146, 146, 146, 0.1); /* Semi-transparent background */
                      backdrop-filter: blur(1px); /* Apply blur effect to the background */
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      z-index: 9999; /* Ensure it appears on top */
                    }

                    /* Style for the loading spinner or image */
                    .loading-overlay .text-center {
                      color: white;
                      font-size: 24px;
                      font-weight: bold;
                    }

                  `}
            </style>
    </div>
  );
};

export default Minority;